import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/cotizaciones/editar/{id}", "documento": "quotation", "acceso": "sesion", "filas": ["090"], "cita": "Areas/Quotation/Controllers/QuotationController.cs"} satisfies RutaProd;
